export const mapTextId = (item: string) => {
  const changeText: Record<string, any> = {
    'canRefresh': 'refresh',
    'canReturn': 'return',
    'canReportBroken': 'broken',
    'canReportOwnershipError': 'report_owner',
    'canRegisterOwnership': 'register',
    'canReportMissing': 'missing',
    'addressLine1': 'address_line_1',
    'addressLine2': 'address_line_2',
    'postalCode': 'postal_code',
    'city': 'city',
    'states': 'states',
    'postcode': 'post_code',
    'postalcode': 'postal_code',
    'suburb': 'suburb',
    'zipCode': 'zip_code',
    'town': 'town',
    'district': 'district',
    'province': 'province',
    'canton': 'canton'
  }
  return changeText[item];
};